import ContactsIcon from '@mui/icons-material/Contacts';

import { DirectoryContactList } from './DirectoryContactList';
import { DirectoryContactEdit } from './DirectoryContactEdit';
import { DirectoryContactCreate } from './DirectoryContactCreate';

export default {
    list: DirectoryContactList,
    edit: DirectoryContactEdit,
    create: DirectoryContactCreate,
    icon: ContactsIcon,
};
